// removed by extract-text-webpack-plugin
module.exports = {"PostWrapper":"_2Nt7iZFXbnoF2qjR5Abkxr","Summary":"vNprMzhNVb7FjPU2ZNvu-","StatsText":"_1lPKYimlg7GzKmlXm_wqqT"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/CategoryUpdate/PostHistory/style.css
// module id = 2472
// module chunks = 0